/**
 * Checkbox Component
 *
 * A themed checkbox with label support.
 */

import React, { forwardRef } from 'react';
import { Icon } from '@iconify/react';
import './Checkbox.css';

const Checkbox = forwardRef(({
  checked,
  defaultChecked,
  onChange,
  disabled = false,
  indeterminate = false,
  label,
  description,
  error,
  size = 'md',
  id,
  name,
  value,
  className = '',
  ...props
}, ref) => {
  const inputId = id || name;

  const containerClassNames = [
    'ds-checkbox',
    `ds-checkbox--${size}`,
    disabled && 'ds-checkbox--disabled',
    error && 'ds-checkbox--error',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClassNames}>
      <label className="ds-checkbox__container">
        <input
          ref={ref}
          type="checkbox"
          id={inputId}
          name={name}
          value={value}
          checked={checked}
          defaultChecked={defaultChecked}
          disabled={disabled}
          onChange={onChange}
          className="ds-checkbox__input"
          aria-describedby={description ? `${inputId}-description` : undefined}
          {...props}
        />
        <span className={`ds-checkbox__box ${indeterminate ? 'ds-checkbox__box--indeterminate' : ''}`}>
          {indeterminate ? (
            <Icon icon="mdi:minus" className="ds-checkbox__icon" />
          ) : (
            <Icon icon="mdi:check" className="ds-checkbox__icon" />
          )}
        </span>

        {(label || description) && (
          <span className="ds-checkbox__content">
            {label && <span className="ds-checkbox__label">{label}</span>}
            {description && (
              <span id={`${inputId}-description`} className="ds-checkbox__description">
                {description}
              </span>
            )}
          </span>
        )}
      </label>

      {error && (
        <span className="ds-checkbox__error">{error}</span>
      )}
    </div>
  );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
